import React from "react";

import type { LandingPageContent } from "../content/types";
import { CardVisual } from "./CardVisual";

type ServicesSectionProps = {
  content: LandingPageContent["services"];
};

export function ServicesSection({ content }: ServicesSectionProps) {
  return (
    <section className="db-section section-band" id={content.id} aria-labelledby={`${content.id}-title`}>
      <div className="db-container">
        <div className="section-heading">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id={`${content.id}-title`}>{content.title}</h2>
          <p>{content.lead}</p>
          <p>{content.leadSecondary}</p>
        </div>

        <div className="content-card-grid services-grid">
          {content.items.map((item) => (
            <article
              className={`content-card${item.assetId ? " content-card--visual" : ""}`}
              data-service-card
              data-service-boundary="accounting-service-estimate"
              key={item.title}
            >
              <CardVisual assetId={item.assetId} />
              <h3>{item.title}</h3>
              <p>{item.body}</p>
              {item.tags ? (
                <div className="tag-row" aria-label={item.title}>
                  {item.tags.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </div>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
